import React from "react";
import { motion } from "framer-motion";

const TransitionWrapper = ({ children }) => {
  return (
    <motion.div
    className="w-full"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      {children}
    </motion.div>
  );
};

export default TransitionWrapper;
